module.exports = __webpack_public_path__ + "img/2-2.81508334.png";